import template from "./statements.html";

ko.components.register('statements', {
	template: template
});